/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CheckinRequest } from '../../models/checkin-request';
import { HalJson } from '../../models/hal-json';
import { OrderCheckoutStatus } from '../../models/order-checkout-status';

export interface OrdersOrderIdCheckinPost$Params {
  'Active-Tenant-Identifier': string;
  orderId: string;
      body: CheckinRequest
}

export function ordersOrderIdCheckinPost(http: HttpClient, rootUrl: string, params: OrdersOrderIdCheckinPost$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'_links'?: HalJson;
} & OrderCheckoutStatus>> {
  const rb = new RequestBuilder(rootUrl, ordersOrderIdCheckinPost.PATH, 'post');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('orderId', params.orderId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      '_links'?: HalJson;
      } & OrderCheckoutStatus>;
    })
  );
}

ordersOrderIdCheckinPost.PATH = '/orders/{orderId}/checkin';
